module.exports = __webpack_public_path__ + "static/media/points.9188013b.svg";